"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _bwaCheckoutButton = require("../../apis/bwa/widgets/bwa-checkout-button");
var _constants = require("../../constants/constants");
var _utils = require("../../utils/utils");
var _checkoutRedirectHandler = require("../../utils/checkout-redirect-handler");
var _bwaRedirectInfoWidget = _interopRequireDefault(require("../bwa-redirect-info-widget/bwa-redirect-info-widget"));
var _gaClientIdManager = require("../../utils/ga-client-id-manager");
var _katalFunnelEvents = require("../../events/katal-funnel-events");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BwaBuyNowButtonRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function BwaBuyNowButtonRenderHandler(validateSkuResponse) {
    var _this;
    (0, _classCallCheck2["default"])(this, BwaBuyNowButtonRenderHandler);
    _this = _callSuper(this, BwaBuyNowButtonRenderHandler);
    _this.validateSkuResponse = validateSkuResponse;
    _this.pre.push(function () {
      var _window$isMandateChec, _window$bwaValidateSt;
      _this.config = window.bwaMerchantConfig.bwaBuyButton;
      _this.buyButtonSelector = _this.config.buyButtonSelector;
      _this.bwaCheckoutAddressFillSelectionWidgetId = 'bwa-checkout-address-fill-selection-widget';
      _this.bwaCheckoutAddressFillSelectionWidgetCssClass = 'bwa-checkout-address-fill-selection-widget';
      _this.checkoutButtonWithAddressPrefillId = "#bwa-checkout-button-address-prefill-widget";
      _this.variantIdSelector = window.bwaMerchantConfig.bwaDeliveryBlock.variantIdSelector;
      _this.itemQuantitySelector = window.bwaMerchantConfig.bwaDeliveryBlock.itemQuantitySelector;
      _this.bwaCheckoutButtonIframeIds = ['bwa-checkout-address-fill-selection-widget'];
      _this.storeId = window.storeId;
      _this.storeUrl = window.location.origin;
      _this.isMandateCheckoutEnabled = (_window$isMandateChec = window.isMandateCheckoutEnabled) !== null && _window$isMandateChec !== void 0 ? _window$isMandateChec : true;
      _this.isStoreBwAEnabled = (_window$bwaValidateSt = window.bwaValidateStoreResponse) === null || _window$bwaValidateSt === void 0 ? void 0 : _window$bwaValidateSt.isStoreBwAEnabled;
    });
    return _this;
  }
  (0, _inherits2["default"])(BwaBuyNowButtonRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(BwaBuyNowButtonRenderHandler, [{
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this2 = this;
        var _this$redirectInfoWid, _this$redirectInfoWid2, enableBtn;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.setupEventListeners();
              if (this.isMandateCheckoutEnabled && (0, _utils.getRtoTreatment)() !== _constants.TREATMENTS.CONTROL && this.isStoreBwAEnabled && (0, _utils.isCheckoutOfferingActive)()) {
                this.disableBuyButton();
                this.redirectInfoWidget = new _bwaRedirectInfoWidget["default"]({
                  buttonSelector: this.buyButtonSelector,
                  useMutationObserver: true,
                  isHidden: true
                });
                enableBtn = function enableBtn() {
                  return _this2.enableBuyButton();
                };
                (_this$redirectInfoWid = this.redirectInfoWidget.renderHandler.iframeResolved) === null || _this$redirectInfoWid === void 0 || _this$redirectInfoWid.then(enableBtn);
                setTimeout(enableBtn, 2000);
                (_this$redirectInfoWid2 = this.redirectInfoWidget.renderHandler) === null || _this$redirectInfoWid2 === void 0 || _this$redirectInfoWid2.applyRepeatCustomerVisibility();
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this3 = this;
      this.observeBuyNowButton();
      this.setupQuickCheckoutDismissListener();
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
          _this3.enableBuyButton();
        }
      });
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.VARIANT_UPDATED, /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(event) {
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.trackVariantButtons(event.detail.validateSkuResponse);
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      if (!this.isMandateCheckoutEnabled) {
        _checkoutRedirectHandler.CheckoutRedirectHandler.setupMessageListener({
          expectedButtonType: _constants.SESSION_STORAGE_VALUES.BUY_NOW_BUTTON,
          buttonName: _constants.BUTTON_NAMES.BUY_NOW,
          checkoutButtonWithAddressPrefillId: this.checkoutButtonWithAddressPrefillId,
          storeUrl: this.storeUrl,
          storeId: this.storeId,
          bwaCheckoutButtonIframeIds: this.bwaCheckoutButtonIframeIds,
          getCartDetails: function () {
            var _getCartDetails = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
              var quantityInput, selectedQuantity, variantId;
              return _regenerator["default"].wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    quantityInput = (0, _utils.safeQuerySelector)(_this3.itemQuantitySelector);
                    selectedQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
                    variantId = (0, _utils.getVariantId)(_this3.variantIdSelector);
                    return _context3.abrupt("return", [{
                      variantId: variantId,
                      quantity: selectedQuantity
                    }]);
                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            function getCartDetails() {
              return _getCartDetails.apply(this, arguments);
            }
            return getCartDetails;
          }(),
          hideCheckoutAddressSelectionDialog: function hideCheckoutAddressSelectionDialog() {
            return _this3.hideCheckoutAddressSelectionDialog();
          }
        });
      }
    }
  }, {
    key: "observeBuyNowButton",
    value: function observeBuyNowButton() {
      var _this4 = this;
      var selector = this.buyButtonSelector;
      if (!selector) return;
      var observer = new MutationObserver(function () {
        var btn = (0, _utils.safeQuerySelector)(selector);
        if (btn) _this4.overrideBuyNowButton(btn);
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      var initialBtn = (0, _utils.safeQuerySelector)(selector);
      if (initialBtn) this.overrideBuyNowButton(initialBtn);
    }
  }, {
    key: "overrideBuyNowButton",
    value: function overrideBuyNowButton(button) {
      var _this$validateSkuResp;
      if (!button || button.dataset.customListenerAttached) return;
      var isSkuEligible = this.isMandateCheckoutEnabled || ((_this$validateSkuResp = this.validateSkuResponse) === null || _this$validateSkuResp === void 0 ? void 0 : _this$validateSkuResp.isSkuEnabled) === true;
      var isRtoControl = this.isMandateCheckoutEnabled && (0, _utils.getRtoTreatment)() === _constants.TREATMENTS.CONTROL;
      var shouldTakeOverButton = (0, _utils.isCheckoutOfferingActive)() && isSkuEligible && !isRtoControl;
      if (!shouldTakeOverButton) {
        // Tracked under its own marker, NOT customListenerAttached: trackVariantButtons()
        // re-enters here on every variant change, and eligibility can flip (a non-BwA variant
        // followed by a BwA-enabled one in non-mandate mode). Reusing the take-over flag would
        // short-circuit that re-entry and leave BwA permanently off an eligible SKU.
        if (button.dataset.bwaObserveOnlyAttached) return;
        button.dataset.bwaObserveOnlyAttached = "true";
        button.addEventListener('click', function () {
          window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.CLICK_NATIVE_BUY_NOW_BUTTON));
        }, {
          passive: true
        });
        return;
      }
      var self = this;
      var cloned = button.cloneNode(true);
      // cloneNode drops listeners, so any passive listener attached on an earlier, ineligible
      // variant is gone; clear its marker so the clone does not advertise one.
      delete cloned.dataset.bwaObserveOnlyAttached;
      button.replaceWith(cloned);
      cloned.dataset.customListenerAttached = "true";
      cloned.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.LAST_CLICKED_BUTTON_TYPE, _constants.SESSION_STORAGE_VALUES.BUY_NOW_BUTTON);
        window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.CLICK_NATIVE_BUY_NOW_BUTTON));
        if (self.isMandateCheckoutEnabled) {
          if ((0, _utils.isEmbeddedCheckoutEnabled)()) {
            self.triggerEmbeddedCheckout();
          } else if ((0, _utils.isBwARepeatCustomer)()) {
            (0, _katalFunnelEvents.logFunnelEvent)(_katalFunnelEvents.FUNNEL_EVENTS.QC_BUTTON_CLICKED);
            self.triggerQuickCheckout();
          } else {
            (0, _katalFunnelEvents.logFunnelEvent)(_katalFunnelEvents.FUNNEL_EVENTS.MANDATE_BUTTON_CLICKED);
            self.triggerMandateCheckout();
          }
        } else {
          self.injectCheckoutAddressFillSelectionWidget();
        }
      });
    }
  }, {
    key: "disableBuyButton",
    value: function disableBuyButton() {
      var buyButton = (0, _utils.safeQuerySelector)(this.buyButtonSelector);
      if (buyButton) {
        buyButton.disabled = true;
        buyButton.classList.add('checkout-button--disabled');
      }
    }
  }, {
    key: "enableBuyButton",
    value: function enableBuyButton() {
      var buyButton = (0, _utils.safeQuerySelector)(this.buyButtonSelector);
      if (buyButton) {
        buyButton.disabled = false;
        buyButton.classList.remove('checkout-button--disabled');
      }
    }
  }, {
    key: "getSelectedItem",
    value: function getSelectedItem() {
      var quantityInput = (0, _utils.safeQuerySelector)(this.itemQuantitySelector);
      var selectedQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      var variantId = (0, _utils.getVariantId)(this.variantIdSelector);
      return {
        variantId: variantId,
        quantity: selectedQuantity
      };
    }
  }, {
    key: "triggerMandateCheckout",
    value: function triggerMandateCheckout() {
      var _this5 = this;
      this.disableBuyButton();
      var _this$getSelectedItem = this.getSelectedItem(),
        variantId = _this$getSelectedItem.variantId,
        quantity = _this$getSelectedItem.quantity;
      this.redirectInfoWidget.renderHandler.setOnCheckoutFailed(function () {
        _this5.enableBuyButton();
      });
      this.redirectInfoWidget.renderHandler.sendCheckoutMessage({
        cartDetails: [{
          variantId: variantId,
          quantity: quantity
        }],
        storeUrl: this.storeUrl,
        storeId: this.storeId,
        buttonId: this.checkoutButtonWithAddressPrefillId
      });
    }
  }, {
    key: "triggerQuickCheckout",
    value: function triggerQuickCheckout() {
      this.disableBuyButton();
      try {
        var _this$getSelectedItem2 = this.getSelectedItem(),
          variantId = _this$getSelectedItem2.variantId,
          quantity = _this$getSelectedItem2.quantity;
        window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_TRIGGER, {
          detail: {
            items: "".concat(variantId, ":").concat(quantity),
            gaClientId: _gaClientIdManager.GaClientIdManager.getGaClientId() || '',
            ecpSessionId: sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.ECP_SESSION_ID) || '',
            ecpCustomerId: _constants.SHOPIFY_PLACEHOLDER_CUSTOMER_ID
          }
        }));
      } catch (error) {
        this.enableBuyButton();
      }
    }
  }, {
    key: "triggerEmbeddedCheckout",
    value: function () {
      var _triggerEmbeddedCheckout = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var _this$getSelectedItem3, variantId, quantity, _yield$this$redirectI, checkoutId, returnUrl, url;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.disableBuyButton();
              _context4.prev = 1;
              _this$getSelectedItem3 = this.getSelectedItem(), variantId = _this$getSelectedItem3.variantId, quantity = _this$getSelectedItem3.quantity; // Create the cart up front (same-origin iframe) so /checkout-page can load cart + address
              // in parallel; resolves with the checkoutId and the ECP returnUrl to resume on completion.
              _context4.next = 5;
              return this.redirectInfoWidget.renderHandler.triggerCartCreation({
                cartDetails: [{
                  variantId: variantId,
                  quantity: quantity
                }],
                storeUrl: this.storeUrl,
                storeId: this.storeId
              });
            case 5:
              _yield$this$redirectI = _context4.sent;
              checkoutId = _yield$this$redirectI.checkoutId;
              returnUrl = _yield$this$redirectI.returnUrl;
              url = ((0, _utils.isCognitoLoginEnabled)() ? _utils.buildCheckoutLoaderUrl : _utils.buildCheckoutPageUrl)({
                checkoutId: checkoutId,
                returnUrl: returnUrl,
                ecpCustomerId: _constants.SHOPIFY_PLACEHOLDER_CUSTOMER_ID,
                ecpSessionId: sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.ECP_SESSION_ID) || ''
              });
              window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_EMBEDDED_CHECKOUT_TRIGGER, {
                detail: {
                  url: url
                }
              }));
              _context4.next = 15;
              break;
            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](1);
              this.enableBuyButton();
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 12]]);
      }));
      function triggerEmbeddedCheckout() {
        return _triggerEmbeddedCheckout.apply(this, arguments);
      }
      return triggerEmbeddedCheckout;
    }()
  }, {
    key: "setupQuickCheckoutDismissListener",
    value: function setupQuickCheckoutDismissListener() {
      var _this6 = this;
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_DISMISS, function () {
        _this6.enableBuyButton();
      });
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_EMBEDDED_CHECKOUT_DISMISS, function () {
        _this6.enableBuyButton();
      });
    }
  }, {
    key: "injectCheckoutAddressFillSelectionWidget",
    value: function injectCheckoutAddressFillSelectionWidget() {
      var _this7 = this;
      var modalContainer = document.createElement("div");
      modalContainer.id = 'bwa-checkout-address-fill-selection-container';
      modalContainer.className = 'bwa-checkout-address-fill-selection-container-modal';
      var iframe = (0, _bwaCheckoutButton.checkoutAddressFillSelectionWidget)(this.bwaCheckoutAddressFillSelectionWidgetId, this.bwaCheckoutAddressFillSelectionWidgetCssClass);
      modalContainer.appendChild(iframe);
      document.body.insertBefore(modalContainer, document.body.firstChild);
      modalContainer.classList.add('active');
      modalContainer.addEventListener('click', function (event) {
        if (event.target === modalContainer) {
          _this7.hideCheckoutAddressSelectionDialog();
        }
      });
    }
  }, {
    key: "hideCheckoutAddressSelectionDialog",
    value: function hideCheckoutAddressSelectionDialog() {
      var container = (0, _utils.safeGetElementById)('bwa-checkout-address-fill-selection-container');
      if (container) {
        container.remove();
      }
    }
  }, {
    key: "trackVariantButtons",
    value: function () {
      var _trackVariantButtons = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(validateSkuResponseAfterVariantChange) {
        var currentVariantId, btn;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              currentVariantId = (0, _utils.getVariantIdFromURL)();
              if (currentVariantId && currentVariantId !== this.variantId) {
                this.variantId = currentVariantId;
                this.validateSkuResponse = validateSkuResponseAfterVariantChange;
                btn = (0, _utils.safeQuerySelector)(this.buyButtonSelector);
                if (btn) this.overrideBuyNowButton(btn);
              }
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function trackVariantButtons(_x2) {
        return _trackVariantButtons.apply(this, arguments);
      }
      return trackVariantButtons;
    }()
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=bwa-buy-now-button-render-handler.js.map
